import { Component, OnInit, Inject, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, ValidationErrors, AbstractControl } from '@angular/forms';
import { NgForm } from '@angular/forms';
import {
    MAT_DIALOG_DATA, MatDialogRef, MatSelectModule, MatAutocompleteModule,
    MatDatepickerModule, MatNativeDateModule, MatTabsModule, MatTabChangeEvent, MatTooltipModule, MatDialog
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { User, Region, Region15 } from '../user.model';
import { UserSummary } from '../user-summary.model';
import { UserDetailsDialog } from '../user-details/user-details-dialog.model';
import { UserDetailsComponent } from '../user-details/user-details.component';
import { Team } from '../../teams/team.model';
import { LoanProgram, LoanProgramLoRelationship } from '../../loanprograms/loanprogram.model';
import { Role } from '../../roles/role.model';
import { Persona } from '../../personas/persona.model';
import { UserService } from '../user.service';
import { TimeOff } from '../../timeoff/timeoff.model';
import { LoanProgramService } from '../../loanprograms/loanprogram.service';
import { TeamService } from '../../teams/team.service';
import { RoleService } from '../../roles/role.service';
import { PersonaService } from '../../personas/persona.service';
import { CollateralSkillSet } from '../../collateralskillsets/collateralskillset.model';
import { CollateralskillsetsService } from '../../collateralskillsets/collateralskillsets.service';
import { CondoSkillset, UserCondoSkillset } from '../../condoskillsets/condoSkillset.model';
import { CondoSkillsetsService } from '../../condoskillsets/condoskillsets.service';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.css']
})

export class UserEditComponent implements OnInit {
    public personas: Persona[];
    public partnerControl: FormControl = new FormControl();
    public filteredPartners: Observable<User[]>;
    public loanProgramControl: FormControl = new FormControl();
    public skillSetControl: FormControl = new FormControl();
    public condoSkillsetControl: FormControl = new FormControl();

    public teamControl: FormControl = new FormControl();
    public regionControl: FormControl = new FormControl();
    public filteredLoanPrograms: Observable<LoanProgram[]>;
    public filteredSkillsets: Observable<CollateralSkillSet[]>;
    public filteredCondoSkillsets: Observable<CondoSkillset[]>;
    public relationship_error: string;
    public submitReady: boolean = false;
    public roles: Role[];
    public userForm: FormGroup;
    public relatedPersonas: string[] = [];
    public userTeams: Team[];
    public teams: Team[];
    public userCondoSkillsets: UserCondoSkillset[];
    public originalUserRegions: Region[];
    public userRegions: Region[];
    public regions: Region[];
    public whiteGloveOptions: string[];
    public isSuccess: boolean = false;
    public isFail: boolean = false;
    public hasWarnings: boolean = false;
    public detailedErrors: string[];
    public availableLoanPrograms: LoanProgram[] = [];
    public availableSkillsets: CollateralSkillSet[] = [];
    public availableCondoSkillsets: CondoSkillset[] = [];
    public isCollateralUW = false;
    public isCondoUnderwriter = false;

    public loanPrograms: LoanProgram[] = [];
    public timeOffDays: TimeOff[] = [];
    public partners: User[] = [];
    public date_error: string;
    public timeOffStart: Date;
    public timeOffEnd: Date;
    public pickerStart: Date;
    public pickerEnd: Date;
    public user: User;
    public activeTab: string;
    public collateralSkillSets: CollateralSkillSet[] = [];
    public condoSkillsets: CondoSkillset[] = [];
    public encompassUserNameValue: string;
    public isLoRelationship = false;
    public isRegion15 = false;

    @ViewChild('tg') vcTg: any;
    @ViewChild('loRelationshipCheckbox', { read: ElementRef }) loRelationshipCheckbox: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<UserEditComponent>,
        public dialogRef2: MatDialogRef<UserDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public userDetailsDialog: UserDetailsDialog,
        private fb: FormBuilder, private userService: UserService,
        private teamService: TeamService,
        private loanProgramService: LoanProgramService,
        private roleService: RoleService,
        private ref: ChangeDetectorRef,
        public dialog: MatDialog,
        private personaService: PersonaService,
        private collateralSkillsetService: CollateralskillsetsService,
        private condoSkillsetService: CondoSkillsetsService    ) {
        this.user = userDetailsDialog.user;
    }

    ngOnInit() {
        if (this.user.warningMessages != null) {
            this.hasWarnings = true;
        }
        if (this.user.persona == "Collateral UW") {
            this.isCollateralUW = true;
        }
        if (this.user.persona == "Condo Underwriter"){
            this.isCondoUnderwriter = true;
        }
        if (this.user.whiteGlove == "Region 15") {
            this.isRegion15 = true;
        }

        this.getCollateralSkillSets();
        this.getTeams();
        this.userTeams = this.user.teams;
        this.getRoles();
        this.getWhiteGloveOptions();
        this.getPersonas();
        this.getUsers();
        this.getLoanPrograms();
        this.findUniqueRelatedPersonas();
        this.getCondoSkillsets();
        this.getUserCondoSkillsets();
        this.setActiveEditTab(this.userDetailsDialog.activeTab);
        this.loanPrograms = this.user.loanPrograms;
        this.collateralSkillSets = this.user.collateralSkillsets;
        this.encompassUserNameValue = this.user.encompassUserName
        this.filteredPartners = this.partnerControl.valueChanges
            .startWith(null)
            .map(val => val ? this.filterPartners(val.name ? val.name : val) : this.partners.slice());

        this.filteredLoanPrograms = this.loanProgramControl.valueChanges
            .startWith(null)
            .map(val => val ? this.filterLoanPrograms(val) : this.availableLoanPrograms.slice());

        var groupName = this.user.persona ==  "Loan Officer" ? "Underwriting" : "Closer";
        this.loanProgramService.getRegionAssignmentStrategiesByGroupName(groupName).then(
            result => {
                result.sort((a, b) => a.name.localeCompare(b.name));
                this.regions = JSON.parse(JSON.stringify(result));
            }
        )
            .catch(error => console.log(error));

        this.userService.getAssignedRegions(this.user.id).then(
            result => {
                this.userRegions = JSON.parse(JSON.stringify(result));
                this.originalUserRegions = JSON.parse(JSON.stringify(result));
                var regionValue = this.userRegions.length === 0 ? "" : this.userRegions[0].id
                this.userForm.patchValue({ region : regionValue });
            }
        )
            .catch(error => console.log(error));

        this.filteredSkillsets = this.skillSetControl.valueChanges
            .startWith(null)
            .map(val => {
                return val ? this.filterSkillsets(val) : this.availableSkillsets.slice()
            });

        this.filteredCondoSkillsets = this.condoSkillsetControl.valueChanges
            .startWith(null)
            .map(val => {
                return val ? this.filterCondoSkillsets(val) : this.availableCondoSkillsets.slice();
            })

        this.createForm();
    }

    getPartnerName(partner: User) {
        if (partner) {
            return partner.name;
        }
        return null;
    }

    setActiveEditTab(activeTab: string) {
        if (activeTab === 'Profile' || activeTab === null) {
            this.vcTg.selectedIndex = 0;
        }
        if (activeTab === 'Loan Programs') {
            this.vcTg.selectedIndex = 1;
        }
        if (activeTab === 'Relationships') {
            this.vcTg.selectedIndex = 2;
        }
    }

    updateRegionForProfileType(unfilteredRegions: Region[]) {
        if (this.user.persona == "Loan Officer") {
            return unfilteredRegions.filter(x => x.group == "Underwriting");
        }
        else {
            return unfilteredRegions.filter(x => x.group == null ||x.group == "Closer" || x.group == "Region 15");
        }
    }

    disableOutdatedPersona(persona: Persona) {
        var outdatedPersonas = ['Quick Approval UW', 'Fast Track UW'];
        return outdatedPersonas.includes(persona.name);
    }

    setRegionRequiredForLoanOfficer() {
        if (this.user.persona == "Loan Officer") {
            this.userForm.controls['region'].setValidators([Validators.required]);
            this.userForm.controls['region'].updateValueAndValidity();
        }
    }

    findUniqueRelatedPersonas() {
        // Get all personas from related users
        const personas: string[] = this.user.relationships.map(data => data.persona);

        // Unique personas
        this.relatedPersonas = personas.filter((x, i, a) => x && a.indexOf(x) === i);
    }

    isTeamEmailEnabledPersona() {
        if (this.personas) {
            var loanOfficerPersona = this.personas.find(x => x.name === "Loan Officer");
            return this.userForm.value.persona == loanOfficerPersona.id;
        }
    }

    private nullOrEmailValidator(control: AbstractControl): ValidationErrors {
        if (!control.value) {
            return null;
        }

        return Validators.email(control);
    }

    createForm() {
        this.userForm = this.fb.group({
            persona: [null, Validators.required],
            role: [null, Validators.required],
            encompassUserName: [null, Validators.required],
            teamEmail: [null, this.nullOrEmailValidator],
            email: [null, Validators.compose([Validators.required, Validators.email])],
            lastName: [null, Validators.required],
            firstName: [null, Validators.required],
            isLead: [],
            capacity: [null, Validators.compose([Validators.nullValidator, Validators.pattern('[0-9]*')])],
            whiteGlove: [null, Validators.required],
            region:[]
        });

        this.userForm.patchValue({
            persona: this.user.personaId,
            role: this.user.roleId,
            isLead: this.user.isLead,
            encompassUserName: this.user.encompassUserName,
            teamEmail: this.user.teamEmail,
            email: this.user.email,
            lastName: this.user.lastName,
            firstName: this.user.firstName,
            capacity: this.user.capacity,
            whiteGlove: this.user.whiteGlove,
        });

        this.setRegionRequiredForLoanOfficer();
    }

    addLoanProgram($event) {
        var value = this.loanProgramControl.value.id;
        var selectedProgram = this.availableLoanPrograms.find(x => x.id === value);

        if (this.loRelationshipCheckbox !== undefined) {
            selectedProgram.isLoRelationship = this.loRelationshipCheckbox.nativeElement.checked;
            this.isLoRelationship = this.loRelationshipCheckbox.nativeElement.checked;
            this.loRelationshipCheckbox.nativeElement.checked = false;
        }

        if (selectedProgram !== undefined) {
            if (this.user.loanPrograms.find(x => x.id === selectedProgram.id) === undefined) {
                this.user.loanPrograms.push(selectedProgram);
            }
            this.loanProgramControl.reset();
        }
    }

    addSkillset($event) {
        var value = this.skillSetControl.value.id;
        var selectedSkillset = this.availableSkillsets.find(x => x.id === value);
        if (selectedSkillset !== undefined) {
            if (this.user.collateralSkillsets.find(x => x.id === selectedSkillset.id) === undefined) {
                this.user.collateralSkillsets.push(selectedSkillset);
            }
            this.skillSetControl.reset();
        }
    }

    addCondoSkillset($event) {
        var value = this.condoSkillsetControl.value.id;
        var selectedCondoSkillset = this.availableCondoSkillsets.find(x => x.id === value);

        if (selectedCondoSkillset !== undefined) {
            if (this.userCondoSkillsets == undefined || this.userCondoSkillsets.find(x => x.condoSkillset.id === selectedCondoSkillset.id) === undefined) {
                var skillsetToAdd = new UserCondoSkillset();
                skillsetToAdd.condoSkillset = selectedCondoSkillset;
                this.userCondoSkillsets.push(skillsetToAdd);
            }

            this.condoSkillsetControl.reset();
        }
    }

    addTeam($event) {
        var value = this.teamControl.value;
        var selectedTeam = this.teams.find(x => x.id === value);
        if (selectedTeam !== undefined) {
            if (this.user.teams.find(x => x.id === selectedTeam.id) === undefined) {
                this.userTeams.push(selectedTeam);
            }
            this.teamControl.reset();
        }
    }

    addRegion($event) {
        var value = this.regionControl.value;
        var selectedRegion = this.regions.find(x => x.id === value);
        if (selectedRegion !== undefined) {
            if (this.userRegions.find(x => x.id === selectedRegion.id) === undefined) {
                this.userRegions.push(selectedRegion);
            }
            this.regionControl.reset();
        }
    }

    onUnderwriterRegionSelectionChange(event) {
        this.userRegions.length = 0;

        var userForm = this.userForm.value;
        var selectedRegion = this.regions.find(x => x.id === userForm.region);
        if (selectedRegion !== undefined) {
            if (this.userRegions.find(x => x.id === selectedRegion.id) === undefined) {
                this.userRegions.push(selectedRegion);
            }
            this.regionControl.reset();
        }
    }

    onWhiteGloveSelectionChange(event) {
        if (event.value == "Region 15") {
            this.isRegion15 = true;
        }
        else {
            this.isRegion15 = false;
        }
    }

    displayLoanProgram(loanProgram: LoanProgram) {
        return loanProgram ? loanProgram.name : loanProgram;
    }

    displaySkillset(collateralSkillset: CollateralSkillSet) {
        return collateralSkillset ? collateralSkillset.name : collateralSkillset;
    }

    displayCondoSkillset(condoSkillset: CondoSkillset) {
        return condoSkillset ? condoSkillset.condoSkillsetName : condoSkillset;
    }

    addPartner($event) {
        this.relationship_error = null;
        var value = this.partnerControl.value;
        var selectedUser = this.partners.find(x => x.name === value.name && x.persona === value.persona);
        if (selectedUser !== undefined) {
            if (this.user.relationships.find(x => x.id === selectedUser.id) === undefined) {
                this.user.relationships.push(selectedUser);
                this.findUniqueRelatedPersonas();
            }
            else {
                this.relationship_error = this.partnerControl.value.name + ' already has a work relationship with ' + this.user.name;
            }
        }
        this.partnerControl.reset();
    }

    addTimeOff(timeOffStart: Date, timeOffEnd: Date) {
        this.ref.detectChanges();
        this.pickerStart = null;
        this.pickerEnd = null;
        var today = new Date();
        var start = new Date(timeOffStart);
        var end = new Date(timeOffEnd);
        var currentYear = today.getFullYear();
        if (start.getFullYear() < currentYear) start.setFullYear(currentYear);
        if (end.getFullYear() < currentYear) end.setFullYear(currentYear);
        var timeOff = new TimeOff(start, end);
        if (timeOffStart && timeOffEnd) {
            this.date_error = "";
            this.user.timeOffDateRanges.push(timeOff);
        }
        else {
            this.date_error = "Please enter a start and an end date.";
        }
    }

    myFilter = (d: Date): boolean => {
        var userDates = this.user.timeOffDateRanges;
        const day = d.getDay();
        var yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return this.getUnavailableDates(userDates, d) && (day !== 0 && day !== 6) && (d > yesterday);
    }

    getUnavailableDates(userDates: TimeOff[], d: Date) {
        for (var i = 0; i < userDates.length; i++) {
            if (d >= new Date(userDates[i].timeOffStart) && d <= new Date(userDates[i].timeOffEnd)) {
                return false;
            }
        }
        return true;
    }

    blurInput($event) {
        $event.target.blur();
    }

    onSubmit() {
        if (!this.userForm.valid)
            return;

        this.isFail = false;
        this.isSuccess = false;
        this.detailedErrors = [];
        this.user = this.prepareSaveUser();
        this.userService.saveAssignedRegions(this.user.id, this.originalUserRegions, this.userRegions);
        this.condoSkillsetService.saveAssignedCondoSkillsets(this.user.id, this.user.loggedInUserEmail, this.userCondoSkillsets.map(x => x.condoSkillset));

        this.putUser();
    }

    getLoggedInUser() {
        var loggedInUser = this.userService.currentUser;
        return loggedInUser;
    }

    putUser() {
        this.hasWarnings = false;
        this.userService.putUser(this.user, this.user.id)
            .then(resp => {
                this.isSuccess = true;
                this.dialogRef.close();
            }).catch(err => {
                this.detailedErrors = err as string[];
                this.isFail = true;
            });
    }

    prepareSaveUser(): User {
        var formModel = this.userForm.value;
        var relationshipGuids: string[] = [];
        var teamGuids: string[] = [];
        this.user.relationships.forEach(x => relationshipGuids.push(x.id));
        this.userTeams.forEach(x => teamGuids.push(x.id));
        var loanProgramGuids: string[] = [];
        this.user.loanPrograms.forEach(x => loanProgramGuids.push(x.id));
        var collateralSkillsetGuids: string[] = [];
        this.user.collateralSkillsets.forEach(x => collateralSkillsetGuids.push(x.id));
        var userLoanProgramUpdates: LoanProgramLoRelationship[] = [];
        this.user.loanPrograms.forEach(x => {
            var tempLoanProgramUpdate = new LoanProgramLoRelationship;
            tempLoanProgramUpdate.loanProgramId = x.id;
            tempLoanProgramUpdate.isLoRelationship = x.isLoRelationship;
            userLoanProgramUpdates.push(tempLoanProgramUpdate);
        });

        var newRegion15 = new Region15;
        newRegion15.userId = this.user.id;
        newRegion15.option = "";

        var saveUser = new User;
        saveUser.id = this.user.id;
        saveUser.lastName = formModel.lastName;
        saveUser.firstName = formModel.firstName;
        saveUser.encompassUserName = formModel.encompassUserName;
        saveUser.teamEmail = formModel.teamEmail;
        saveUser.relationships = this.user.relationships;
        saveUser.relationshipIds = relationshipGuids;
        saveUser.personaId = formModel.persona;
        saveUser.roleId = formModel.role;
        saveUser.whiteGlove = formModel.whiteGlove;
        saveUser.email = formModel.email;
        saveUser.isLead = formModel.isLead;
        saveUser.teams = this.userTeams;
        saveUser.teamIds = teamGuids;
        saveUser.collateralSkillsetIds = collateralSkillsetGuids;
        saveUser.loanPrograms = this.user.loanPrograms;
        saveUser.loanProgramIds = loanProgramGuids;
        saveUser.loanProgramLoRelationships = userLoanProgramUpdates;
        saveUser.timeOffDateRanges = this.user.timeOffDateRanges;
        saveUser.capacity = formModel.capacity;
        saveUser.loggedInUserEmail = this.getLoggedInUser().email;
        saveUser.region15 = newRegion15;
        return saveUser;
    }

    getPersonas() {
        this.personaService.getPersonasCache()
            .then(resp => {
                this.personas = resp;
            })
    }

    getLoanPrograms() {
        this.loanProgramService.getLoanPrograms()
            .then(resp => {
                this.availableLoanPrograms = resp;
                this.submitReady = true;
            })
    }

    getRoles() {
        this.roleService.getRolesCache()
            .then(resp => {
                this.roles = resp;
            })
    }

    getWhiteGloveOptions() {
        this.whiteGloveOptions = this.userService.getWhiteGloveOptions();
    }

    getTeams() {
        this.teamService.getTeamsCache()
            .then(resp => {
                this.teams = resp;
            });
    }

    getUsers() {
        this.userService.getUsers()
            .then(resp => {
                this.partners = resp;
            })
    }

    deleteRelationship(relatedUser: User) {
        var removeIndex = this.user.relationships.indexOf(relatedUser);
        this.user.relationships.splice(removeIndex, 1);
    }

    filterPartners(val: string): User[] {
        return this.partners.filter(partner =>
            partner.name.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }

    filterLoanPrograms(val: any): LoanProgram[] {
        if (typeof val.toLowerCase !== "undefined")
            var lowerVal = val.toLowerCase();
        return this.availableLoanPrograms.filter(s =>
            (s.name.toLowerCase().indexOf(lowerVal) !== -1));
    }

    filterSkillsets(val: any): CollateralSkillSet[] {
        if (typeof val.toLowerCase !== "undefined")
            var lowerVal = val.toLowerCase();
        return this.availableSkillsets.filter(s =>
            (s.name.toLowerCase().indexOf(lowerVal) !== -1));
    }

    filterCondoSkillsets(val: any): CondoSkillset[] {
        if (typeof val.toLowerCase !== "undefined")
            var lowerVal = val.toLowerCase();
        return this.availableCondoSkillsets.filter(s =>
            (s.condoSkillsetName.toLowerCase().indexOf(lowerVal) !== -1));
    }

    isCapacityEnabledPersona() {
        if (this.personas) {
            var underwriterPersonas = this.personas.filter(x => x.name === "Underwriter" || x.name === "UW 1" || x.name === "Collateral UW" || x.name == "Condo Underwriter");
            return underwriterPersonas.some(x => x.id === this.userForm.value.persona);
        }
    }

    onChange(event) {
        this.isCollateralUW = event.value == this.personas.find(x => x.name === "Collateral UW").id;
        this.isCondoUnderwriter = event.value == this.personas.find(x => x.name === "Condo Underwriter").id;
    }

    removeLoanProgram(id: string) {
        var removeIndex = this.user.loanPrograms.findIndex(s => s.id == id);
        this.user.loanPrograms.splice(removeIndex, 1);
    }

    removeSkillset(id: string) {
        var removeIndex = this.user.collateralSkillsets.findIndex(s => s.id == id);
        this.user.collateralSkillsets.splice(removeIndex, 1);
    }

    removeCondoSkillset(id: string) {
        var removeIndex = this.userCondoSkillsets.findIndex(s => s.condoSkillset.id == id);
        this.userCondoSkillsets.splice(removeIndex, 1);
    }

    removeTeam(id: string) {
        var removeIndex = this.user.teams.findIndex(s => s.id === id);
        this.userTeams.splice(removeIndex, 1);
    }

    removeRegion(id: string) {
        var removeIndex = this.userRegions.findIndex(s => s.id === id);
        this.userRegions.splice(removeIndex, 1);
    }

    removeTimeOff(timeOff: TimeOff) {
        var removeIndex = this.user.timeOffDateRanges.indexOf(timeOff);
        this.user.timeOffDateRanges.splice(removeIndex, 1);
    }

    onSelectChange(event) {
        this.activeTab = event.tab.textLabel;
    }

    getCollateralSkillSets() {
        this.collateralSkillsetService.getCollateralSkillsets()
            .then(resp => {
                this.availableSkillsets = resp;
                this.submitReady = true;
            });
    }

    getCondoSkillsets() {
        this.condoSkillsetService.getCondoSkillsets()
            .then(resp => {
                this.availableCondoSkillsets = resp;
            });
    }

    getUserCondoSkillsets() {
        this.condoSkillsetService.getUserCondoSkillsets(this.user.id)
            .then(resp => {
                this.userCondoSkillsets = resp;
            });
    }

    ConvertToLower(event) {
        if (event) {
            this.encompassUserNameValue = this.user.encompassUserName = event.toLowerCase();
        }
    }

    IsUserProcessor() {
        if (this.personas) {
            var userPersona = this.personas.find(x => x.name === "Processor");
            return this.userForm.value.persona == userPersona.id;
        }
    }

    IsUserValidRegionCloser() {
        var isValid = false;

        if (this.personas) {
            var srCloser = this.personas.find(x => x.name === "Sr Closer");
            var icdCloser = this.personas.find(x => x.name === "ICD Closer");

            isValid = this.userForm.value.persona == srCloser.id || this.userForm.value.persona == icdCloser.id;
        }

        return isValid;
    }

    IsUserValidLoanOfficer() {
        var isValid = false;

        if (this.personas) {
            var loanOfficer = this.personas.find(x => x.name === "Loan Officer");
            isValid = this.userForm.value.persona == loanOfficer.id;
        }

        return isValid;
    }

    isLoanProgramEnabledPersona(user: User) {
        return user.persona !== 'Collateral UW'
            && user.persona != 'Condo Underwriter'
            && user.persona !== 'Field Sales Manager';
    }

    isRelationshipEnabledPersona(user: User) {
        return user.persona !== 'Collateral UW' && user.persona !== 'Condo Underwriter';
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-edit/user-edit.component.ts